@if (isProduction$ | async) {
  <mat-card class="warning">
    <mat-card-title class="d-flex align-items-center justify-content-between">
      <span>Warning</span>
      <mat-icon>warning</mat-icon>
    </mat-card-title>
    <mat-card-content>
      Dora Tool is not authorized for production service calls. Therefore the submit button has been removed. For production service calls to EVA, please contact your EVA support contact.
    </mat-card-content>
  </mat-card>
}

<div [hidden]="showLoginAgainUserInterface$ | async">
  @if (selectedServices?.length > 0) {
    <div class="tabs-container">
      <mat-tab-group class="services-tabs" [(selectedIndex)]="selectedTabIndex">
        @for (selectedService of selectedServices; track selectedService; let index = $index) {
          <mat-tab
            [label]="selectedService.tabName || 'Service ' + (index + 1) ">
            <eva-service-tester-info [testerInfo]="selectedServices[index]"></eva-service-tester-info>
          </mat-tab>
        }
      </mat-tab-group>
      <button mat-button (click)="addTab()" class="add-button">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <eva-service-tester [hidden]="!selectedServices[selectedTabIndex]?.listMetaData"
      [testerState]="selectedServices[selectedTabIndex]"
    (editorContainerStateChange)="updateServicesState($event, selectedTabIndex)"></eva-service-tester>
  }

  @if (!selectedServices[selectedTabIndex]?.listMetaData) {
    <eva-empty-state title="Select a service to get started"
      icon="list">
    </eva-empty-state>
  }

</div>
@if (showLoginAgainUserInterface$ | async) {
  <eva-empty-state
    title="Your session timed out, please login to continue"
    icon="error">
    <div class="d-flex justify-content-center mt-3">
      <button mat-button (click)="openLoginModal()">
        Login in EVA
      </button>
      <button mat-button color="warn" (click)="forceHideLoginAgainUserInterface()">
        Use anonymous services
      </button>
    </div>
  </eva-empty-state>
}
